module.exports = __webpack_public_path__ + "44cda8b7e553cc04d532236c4822f3b2.pdf";